/**
 * Set of ARIA utils
 */

/**
 * Set aria hidden and expanded for drawer like elements.
 * @param {HTMLElement} el
 * @param {Boolean} isOpening
 */
export const setAriaDrawerTags = (el, isOpening) => {
  if (el) {
    const controls = document.querySelector(`[aria-controls="${el.id}"]`);
    el.setAttribute('aria-hidden', !isOpening);
    controls && controls.setAttribute('aria-expanded', isOpening);
    return el;
  }
  return null;
};

/**
 * Set aria hidden for an array of HTMLElements elements.
 * @param {Array} elementArray - Array of HTMLElements. i.e ['div.booking-widget__input-group', '.hero']
 * @param {Boolean} isHidden
 */
export const setAriaHiddenByElementAttribute = (elementArray, isHidden) => {
  const elements = [...document.querySelectorAll(elementArray)];
  elements.forEach(elem => {
    elem?.setAttribute('aria-hidden', isHidden);
  });
};
